import { api } from './apiClient';

const throwApiError = (error, fallback) => {
  if (error.response) {
    const errorData = error.response.data;
    if (Array.isArray(errorData?.errors) && errorData.errors.length > 0) {
      throw new Error(errorData.errors.join(', '));
    }
    throw new Error(errorData?.message || `Server error: ${error.response.status}`);
  }
  if (error.request) {
    throw new Error(
      'Unable to reach the server. Please check your internet connection or try again later.'
    );
  }
  throw new Error(error.message || fallback);
};

/**
 * List Krishna Karma Time Plans
 * POST /api/v1/admin/krishna-karma-time-plans/list
 */
export const fetchKrishnaKarmaTimePlansList = async (
  page = 1,
  pageSize = 20,
  searchtext = '',
  isActive
) => {
  try {
    const body = {
      pagination: { page, pageSize },
      searchtext: searchtext || '',
    };
    if (typeof isActive === 'boolean') {
      body.is_active = isActive;
    }
    const response = await api.post('/api/v1/admin/krishna-karma-time-plans/list', body);
    return response.data;
  } catch (error) {
    throwApiError(error, 'Failed to load plans');
  }
};

/**
 * Get single plan
 * GET /api/v1/admin/krishna-karma-time-plans/:plan_id
 */
export const getKrishnaKarmaTimePlan = async (planId) => {
  if (!planId) throw new Error('Plan ID is required');
  try {
    const response = await api.get(`/api/v1/admin/krishna-karma-time-plans/${planId}`);
    return response.data;
  } catch (error) {
    throwApiError(error, 'Failed to load plan');
  }
};

/**
 * Create plan
 * POST /api/v1/admin/krishna-karma-time-plans
 */
export const createKrishnaKarmaTimePlan = async (payload) => {
  try {
    const response = await api.post('/api/v1/admin/krishna-karma-time-plans', payload);
    return response.data;
  } catch (error) {
    throwApiError(error, 'Failed to create plan');
  }
};

/**
 * Update plan (partial)
 * PUT /api/v1/admin/krishna-karma-time-plans
 * Body must include plan_id + at least one other field
 */
export const updateKrishnaKarmaTimePlan = async (payload) => {
  if (!payload?.plan_id) throw new Error('Plan ID is required');
  try {
    const response = await api.put('/api/v1/admin/krishna-karma-time-plans', payload);
    return response.data;
  } catch (error) {
    throwApiError(error, 'Failed to update plan');
  }
};

/**
 * Soft-deactivate plan
 * DELETE /api/v1/admin/krishna-karma-time-plans/:plan_id
 */
export const deactivateKrishnaKarmaTimePlan = async (planId) => {
  if (!planId) throw new Error('Plan ID is required');
  try {
    const response = await api.delete(`/api/v1/admin/krishna-karma-time-plans/${planId}`);
    return response.data;
  } catch (error) {
    throwApiError(error, 'Failed to deactivate plan');
  }
};
